<template lang="pug">
  .report
    .flex
      label.fs-17(style="font-weight: bold; grid-column: 1/3; margin-bottom: 10px") quais informações mostrar?
      PCheckbox(v-model="reportOptions.advEmpInfo" :label="`PIS, função e empregador dos ${$wp('employee')}`")
      PCheckbox(v-model="reportOptions.companyInfo" label="estados e cidades dos locais de trabalho")
      PCheckbox(v-model="reportOptions.supervisorInfo" label="supervisor do local de trabalho")
      PCheckbox(v-model="reportOptions.fired" label="ignorar demitidos no mês")

    .button
      PButton(color="success" size="md" @click="generate('excel')" :loading="loading" :disabled="!valid") gerar excel
</template>

<script>
import { setAmplitudeEvent } from 'src/amplitudeUtils'
export default {
  props: {
    reportInfo: {type: Object},
    valid: {type: Boolean}
  },
  data () {
    return {
      loading: false,
      reportOptions: {
        advEmpInfo: false,
        companyInfo: false,
        supervisorInfo: false,
        fired: false
      }
    }
  },
  computed: {
    entity () {
      if (this.reportInfo.entity === 'employer') return 'employers'
      return this.reportInfo.entity
    }
  },
  methods: {
    async generate (typeReport) {
      this.loading = true

      let result

      try {
        result = await this.$API.R05.save({
          entity: this.entity,
          entityContent: this.reportInfo.entityContent.map(i => i.id),
          ...this.reportOptions,
          year: this.reportInfo.periodData.year,
          month: this.reportInfo.periodData.month
        })
        setAmplitudeEvent('gera relatorio R05', {})
      } catch (e) {
        result = e
      }
      this.$emit('handleReport', result)

      this.loading = false
    }
  }
}
</script>

<style scoped lang="scss">
.report {
  display: grid;
  grid-row-gap: 10px;

  .flex {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 20px;
  }
  .button {
    justify-self: end;
  }
}
</style>
